import { WinnerEvent } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const getWinnerEvents: (
  fetchContext: FetchContext,
  programId: number,
  accessToken?: string,
) => Promise<WinnerEvent[]> = (fetchContext, programId, accessToken) => fetch(
  `${fetchContext.baseUrl}/api/staff/programs/${programId}/winner-events`,
  {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  },
).then((response) => responseErrorHandler<WinnerEvent[]>(fetchContext.errorStore, response, 'get winner events'));
